/**
 * 药品管理
 * @param takeMode
 * @param status
 * @returns {string}
 */
export function formatStatus(takeMode, status) {
    let result = "";
    const self = takeMode === "SELF";
    Log(takeMode, status)
    if (status === "WAITTAKE") {
        result = self ? "待取药" : "待配送";
    } else if (status === "SHIPPING") {
        result = self ? "已发药" : "配送中";
    } else if (status === "COMPLETE") {
        result = "已完成";
    } else if (status === "COMMENT") {
        result = "已完成";
    } else if (status === "REFUSE") {
        result = "已拒绝";
    } else if (status === "RECALL") {
        result = "已召回";
    }
    return result;
}